import { Id } from "@dgs/core";
import { CostCategoryOptionResource } from "./costCategory";
import { EventVisibility } from "./event";
import { UserResponsibilityResource } from "./userResponsibility";

export type EventTypeRequirement = "required" | "optional" | "prohibited";

export interface CostCategoryRequirement {
	costCategory: CostCategoryOptionResource;
	requirement: EventTypeRequirement;
}

export interface UserResponsibilityRequirement {
	userResponsibility: UserResponsibilityResource;
	requirement: EventTypeRequirement;
}

export interface EventTypeOptionResource {
	id: Id;
	name: string;
	isEventEditableByAllUsers: boolean;
	showFeedbackEvaluation: boolean;
	color: string | null;
	eventLanguageRequirement: EventTypeRequirement;
	locationRequirement: EventTypeRequirement;
	addressRequirement: EventTypeRequirement;
	organizerRequirement: EventTypeRequirement;
	plannedPersonCountRequirement: EventTypeRequirement;
	formatRequirement: EventTypeRequirement;
	eventCategoryRequirement: EventTypeRequirement;
	industryRequirement: EventTypeRequirement;
	targetGroupRequirement: EventTypeRequirement;
	regionRequirement: EventTypeRequirement;
	primaryOrganizationalUnitRequirement: EventTypeRequirement;
	organizationalUnitRequirement: EventTypeRequirement;
	additionalInfoRequirement: EventTypeRequirement;
	isHighlightRequirement: EventTypeRequirement;
	participationPermissionRequirement: EventTypeRequirement;
	linkToEventRequirement: EventTypeRequirement;
	tagRequirement: EventTypeRequirement;
	preferenceRequirement: EventTypeRequirement;
	eventGoalRequirement: EventTypeRequirement;
	costCategoryRequirements: CostCategoryRequirement[];
	userResponsibilityRequirements: UserResponsibilityRequirement[];
	visitorsMetricRequirement: EventTypeRequirement;
	invitedPersonsMetricRequirement: EventTypeRequirement;
	registrationsMetricRequirement: EventTypeRequirement;
	customersMetricRequirement: EventTypeRequirement;
	employeesMetricRequirement: EventTypeRequirement;
	eventReachMetricRequirement: EventTypeRequirement;
	eventGoalRatingMetricRequirement: EventTypeRequirement;
	allowedVisibilities: EventVisibility[];
}

export function isAllProhibited(eventType: EventTypeOptionResource | null) {
	if (eventType === null) {
		return false;
	}

	return (
		eventType.eventLanguageRequirement === "prohibited" &&
		eventType.locationRequirement === "prohibited" &&
		eventType.addressRequirement === "prohibited" &&
		eventType.organizerRequirement === "prohibited" &&
		eventType.plannedPersonCountRequirement === "prohibited" &&
		eventType.formatRequirement === "prohibited" &&
		eventType.eventCategoryRequirement === "prohibited" &&
		eventType.industryRequirement === "prohibited" &&
		eventType.targetGroupRequirement === "prohibited" &&
		eventType.regionRequirement === "prohibited" &&
		eventType.primaryOrganizationalUnitRequirement === "prohibited" &&
		eventType.organizationalUnitRequirement === "prohibited" &&
		eventType.additionalInfoRequirement === "prohibited" &&
		eventType.isHighlightRequirement === "prohibited" &&
		eventType.participationPermissionRequirement === "prohibited" &&
		eventType.linkToEventRequirement === "prohibited" &&
		eventType.tagRequirement === "prohibited" &&
		eventType.preferenceRequirement === "prohibited" &&
		eventType.eventGoalRequirement === "prohibited" &&
		eventType.visitorsMetricRequirement === "prohibited" &&
		eventType.invitedPersonsMetricRequirement === "prohibited" &&
		eventType.registrationsMetricRequirement === "prohibited" &&
		eventType.customersMetricRequirement === "prohibited" &&
		eventType.employeesMetricRequirement === "prohibited" &&
		eventType.eventReachMetricRequirement === "prohibited" &&
		eventType.eventGoalRatingMetricRequirement === "prohibited" &&
		eventType.costCategoryRequirements.every((r) => r.requirement === "prohibited") &&
		eventType.userResponsibilityRequirements.every((r) => r.requirement === "prohibited")
	);
}
